export const route = {
  home: "/",
  login: "/",
  dashboard: "/dashboard",
  items: "/items",
  processes: "/processes",
  parties: "/parties",
  orders: "/orders",
  payments: "/payments/:id",
  users: "/users",
  employees: "/employees",
  salaries: "/salaries/:id",
  accountTypes: "/account-types",
  accounts: "/accounts",
  jobworks: "/jobworks",
  jobworksParties: "/jobworks-parties",
  jobworksPayments: "/jobworks-payments/:id",
  samples: "/samples",
  purchaseItems: "/purchase-items",
  purchaseParties: "/purchase-parties",
  purchasePayments: "/purchase-payments/:id",
  purchase: "/purchase",
  purchaseCreate: "/purchase/create",
  purchaseEdit: "/purchase/edit/:id",
};
